import { render, staticRenderFns } from "./ol-shared.vue?vue&type=template&id=4960614c&scoped=true"
import script from "./ol-shared.vue?vue&type=script&lang=js"
export * from "./ol-shared.vue?vue&type=script&lang=js"
import style0 from "./ol-shared.vue?vue&type=style&index=0&id=4960614c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960614c",
  null
  
)

export default component.exports